export default __webpack_public_path__ + "static/media/nodata.7e89499b.png";